export const TYPE_IN_STOCK = 139;
export const TYPE_SAMPLES_IN_STOCK = 140;
export const TYPE_PDC_FRONT = 141;
export const TYPE_PDC_REAR = 142;
